/* =============================================================================
   ILHA-ACESSO · gente ou robô, para o Radar medir o tráfego (28/09/2026).
   Pedido: `proa/PEDIDO-APANHAR-ACESSO-RADAR.md`. A classificação NÃO é aqui: é no
   servidor do Radar, para as regras mudarem sem tocar no tema.

   ⛔ As regras do olho, e não se negoceiam:
      · o CONSENTIMENTO de análise confirma-se no instante de enviar; sem ele nada sai
      · nunca cookies, nunca localStorage nem sessionStorage, nunca o IP
      · tudo sai JÁ REDUZIDO: o domínio e não o endereço, baldes e não números, um bit
        e não a placa gráfica, a região e não o fuso

   ⭐ DOIS ENVIOS POR PÁGINA, com a mesma senha `pg`. Medido a 28/09 num Chrome sem ecrã:
      um robô que muda de página ou fecha o separador dispara o `pagehide`; um que abre
      uma página e MATA o navegador não dispara nada. É o robô de preços típico. Por isso:
        · `fa: "i"` aos 2 segundos, para contar quem sai sem avisar;
        · `fa: "f"` à saída, já com o gesto.
      O Radar fica com o último de cada `pg`. A `pg` é ao acaso, só desta página, e não
      passa para a seguinte: não segue ninguém.
   ========================================================================== */
(function () {
  "use strict";
  var CFG_EL = document.getElementById("proa-olho-cfg");
  if (!CFG_EL || !navigator.sendBeacon) return;
  var CFG;
  try { CFG = JSON.parse(CFG_EL.textContent); } catch (e) { return; }
  if (!CFG || !CFG.endereco) return;

  function temConsentimento() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === "function" && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  // A largura do ECRÃ em balde; o «0» é a assinatura de um navegador sem ecrã.
  function baldeLargura(w) {
    return !(w > 0) ? "0" : w < 400 ? "<400" : w < 768 ? "400-767" : w < 1024 ? "768-1023" : "1024+";
  }
  // O envelope, igual ao do olho (a mesma validação no servidor).
  // ⚠️ A largura da JANELA tem os baldes do olho, sem «0» (o servidor recusa-o no envelope).
  function largura() {
    var w = innerWidth;
    return w < 400 ? "<400" : w < 768 ? "400-767" : w < 1024 ? "768-1023" : "1024+";
  }
  function ligacao() {
    var c = navigator.connection, t = c && c.effectiveType;
    return (t === "slow-2g" || t === "2g" || t === "3g" || t === "4g") ? t : null;
  }
  function caminho() {
    var v = null;
    try { v = new URLSearchParams(location.search).get("variant"); } catch (e) {}
    return v ? location.pathname + "?variant=" + v : location.pathname;
  }
  var MODELOS = { product: 1, collection: 1, index: 1, search: 1, cart: 1, page: 1, blog: 1, article: 1, "404": 1, "list-collections": 1 };
  var modelo = String(CFG.tpl || "").split(".")[0];
  if (!MODELOS[modelo]) modelo = "other";

  var ev = { k: "acesso", fa: "i", pg: "", ref: "", ua: "", wd: 0, ln: 0, sw: "0", tq: 0, ig: 0, fh: "?" };
  try {
    var a = new Uint8Array(4);
    crypto.getRandomValues(a);
    for (var i = 0; i < 4; i++) ev.pg += ("0" + a[i].toString(16)).slice(-2);
  } catch (e) { ev.pg = ("0000000" + Math.floor(Math.random() * 4294967295).toString(16)).slice(-8); }
  // ⚠️ O domínio inteiro, sem cortar: cortado a meio deixava de ser domínio e o servidor recusava o envio.
  // ⚠️ Um IPv6 literal («[2001:db8::1]») não passa na validação e deitava fora o envio inteiro:
  //    vai vazio, como quando não há referrer. É raro e não muda a conta do Radar.
  try {
    if (document.referrer) {
      var h = new URL(document.referrer).hostname.replace(/\.$/, "");
      ev.ref = h.indexOf(":") === -1 && h.indexOf("[") === -1 ? h : "";
    }
  } catch (e) {}
  try { ev.ua = String(navigator.userAgent || "").slice(0, 300); } catch (e) {}
  try { ev.wd = navigator.webdriver === true ? 1 : 0; } catch (e) {}
  try { ev.ln = Math.min((navigator.languages || []).length, 5); } catch (e) {}
  try { ev.sw = baldeLargura(screen.width | 0); } catch (e) {}
  try { ev.tq = (navigator.maxTouchPoints | 0) > 0 ? 1 : 0; } catch (e) {}
  try {
    var z = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    ev.fh = z === "Europe/Lisbon" || z === "Atlantic/Madeira" || z === "Atlantic/Azores" ? "PT"
      : z.indexOf("Europe/") === 0 ? "EU"
      : z.indexOf("America/") === 0 ? "AM"
      : z.indexOf("Asia/") === 0 ? "AS"
      : z.indexOf("Africa/") === 0 ? "AF"
      : z ? "XX" : "?";
  } catch (e) {}

  // O GESTO. ⚠️ Sem `scroll`: o browser também rola sozinho (repor a posição, um #âncora),
  // e isso marcava um robô como pessoa. Rodinha, rato, dedo e tecla só vêm de mãos.
  var GESTOS = ["pointermove", "pointerdown", "touchstart", "keydown", "wheel"];
  var OPC = { passive: true, capture: true };
  function gesto() {
    ev.ig = 1;
    for (var j = 0; j < GESTOS.length; j++) removeEventListener(GESTOS[j], gesto, OPC);
  }
  for (var g = 0; g < GESTOS.length; g++) addEventListener(GESTOS[g], gesto, OPC);

  // A PLACA GRÁFICA, reduzida a um bit, com o telemóvel parado. Só sai o «é software»;
  // a cadeia inteira é das maiores impressões digitais que há. Sem WebGL, fica ausente.
  function medirPlaca() {
    try {
      var cv = document.createElement("canvas");
      var gl = cv.getContext("webgl") || cv.getContext("experimental-webgl");
      if (!gl) return;
      var info = gl.getExtension("WEBGL_debug_renderer_info");
      if (info) {
        var r = String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL) || "");
        ev.gs = /swiftshader|llvmpipe|softpipe|software/i.test(r) ? 1 : 0;
      }
      var perder = gl.getExtension("WEBGL_lose_context");
      if (perder) perder.loseContext();
    } catch (e) {}
  }
  if (window.requestIdleCallback) requestIdleCallback(medirPlaca, { timeout: 4000 });
  else setTimeout(medirPlaca, 1500);

  var mandouFim = false;
  function mandar(fase) {
    if (fase === "f" && mandouFim) return;
    if (!temConsentimento()) return;
    if (fase === "f") mandouFim = true;
    ev.fa = fase;
    var corpo = {
      v: 1, t: CFG.t, tp: CFG.tp, tv: CFG.tv, m: modelo, h: CFG.h || null, c: caminho(),
      l: largura(), d: /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent) ? "tel" : "pc",
      r: ligacao(), e: [ev],
    };
    try { navigator.sendBeacon(CFG.endereco, JSON.stringify(corpo)); } catch (e) {}
  }
  setTimeout(function () { if (!mandouFim) mandar("i"); }, 2000);
  addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") mandar("f"); });
  addEventListener("pagehide", function () { mandar("f"); });
})();
